var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
var ContentController = /** @class */ (function () {
    function ContentController() {
    }
    /*****************************************************************************************************
        * Is using route "api/content/categoryById/{id}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {CategoryDownloadDto}
    ******************************************************************************************************/
    ContentController.GetCategoryById = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/categoryById/{id}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/content/Category/mapped" and http method "POST" to call the back-end.
    
        * @param {AdjacentDefinition} definition
        * @returns {ExtendedDataCollection<CategoryDownloadDto, ElementNode<CategoryDownloadDto>[]>}
    ******************************************************************************************************/
    ContentController.GetCategoriesForAllGroupsByGroupTypeMapped = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("definition", JSON.stringify(data.definition));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/Category/mapped", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/content/Category/all/{grouptype?}" and http method "GET" to call the back-end.
    
        * @param {string} grouptype
        * @returns {CategoryDownloadDto[]}
    ******************************************************************************************************/
    ContentController.GetCategoriesForAllGroupsByGroupType = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/Category/all/{grouptype?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/content/ContentPostContentLocation/all/{grouptype?}" and http method "GET" to call the back-end.
    
        * @param {string} grouptype
        * @returns {ContentPostContentLocationDownloadDto[]}
    ******************************************************************************************************/
    ContentController.GetContentPostContentLocationForAllGroupsByGroupType = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/ContentPostContentLocation/all/{grouptype?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/content/ContentPostContentType/all/{grouptype?}" and http method "GET" to call the back-end.
    
        * @param {string} grouptype
        * @returns {ContentPostContentTypeDownloadDto[]}
    ******************************************************************************************************/
    ContentController.GetContentPostContentTypeForAllGroupsByGroupType = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/ContentPostContentType/all/{grouptype?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/content/ContentPostMediaType/all/{grouptype?}" and http method "GET" to call the back-end.
    
        * @param {string} grouptype
        * @returns {ContentPostMediaTypeDownloadDto[]}
    ******************************************************************************************************/
    ContentController.GetContentPostMediaTypeForAllGroupsByGroupType = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/ContentPostMediaType/all/{grouptype?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/content/Category/{groupid}" and http method "GET" to call the back-end.
    
        * @param {string} groupid
        * @returns {CategoryDownloadDto[]}
    ******************************************************************************************************/
    ContentController.GetCategories = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/Category/{groupid}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/content/ContentPostMediaType/{groupid}" and http method "GET" to call the back-end.
    
        * @param {string} groupid
        * @returns {ContentPostMediaTypeDownloadDto[]}
    ******************************************************************************************************/
    ContentController.GetContentPostMediaTypes = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/ContentPostMediaType/{groupid}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/content/ContentPostContentType/{groupid}" and http method "GET" to call the back-end.
    
        * @param {string} groupid
        * @returns {ContentPostContentTypeDownloadDto[]}
    ******************************************************************************************************/
    ContentController.GetContentPostContentType = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/ContentPostContentType/{groupid}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/content/ContentPostContentLocation/{groupid}" and http method "GET" to call the back-end.
    
        * @param {string} groupid
        * @returns {ContentPostContentLocationDownloadDto[]}
    ******************************************************************************************************/
    ContentController.GetContentPostContentLocations = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/ContentPostContentLocation/{groupid}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/content/Category" and http method "POST" to call the back-end.
    
        * @param {File} media
        * @param {CategoryUploadDto} data
        * @param {File} svgFile
        * @param {File} svgFileAlt
        * @param {File} banner
        * @returns {CategoryDownloadDto}
    ******************************************************************************************************/
    ContentController.PostCategory = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.media)
            fd.append("media", data.media);
        fd.append("data", JSON.stringify(data.data));
        if (data.svgFile)
            fd.append("svgFile", data.svgFile);
        if (data.svgFileAlt)
            fd.append("svgFileAlt", data.svgFileAlt);
        if (data.banner)
            fd.append("banner", data.banner);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/Category", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/content/ContentPostMediaType" and http method "POST" to call the back-end.
    
        * @param {File} media
        * @param {ContentPostMediaTypeUploadDto} data
        * @param {File} svgFile
        * @param {File} svgFileAlt
        * @param {File} banner
        * @returns {ContentPostMediaTypeDownloadDto[]}
    ******************************************************************************************************/
    ContentController.PostMediaType = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.media)
            fd.append("media", data.media);
        fd.append("data", JSON.stringify(data.data));
        if (data.svgFile)
            fd.append("svgFile", data.svgFile);
        if (data.svgFileAlt)
            fd.append("svgFileAlt", data.svgFileAlt);
        if (data.banner)
            fd.append("banner", data.banner);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/ContentPostMediaType", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/content/ContentPostContentType" and http method "POST" to call the back-end.
    
        * @param {File} media
        * @param {ContentPostContentTypeUploadDto} data
        * @param {File} svgFile
        * @param {File} svgFileAlt
        * @param {File} banner
        * @returns {ContentPostContentTypeDownloadDto[]}
    ******************************************************************************************************/
    ContentController.PostContentType = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.media)
            fd.append("media", data.media);
        fd.append("data", JSON.stringify(data.data));
        if (data.svgFile)
            fd.append("svgFile", data.svgFile);
        if (data.svgFileAlt)
            fd.append("svgFileAlt", data.svgFileAlt);
        if (data.banner)
            fd.append("banner", data.banner);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/ContentPostContentType", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/content/ContentPostContentLocation" and http method "POST" to call the back-end.
    
        * @param {File} media
        * @param {ContentPostContentLocationUploadDto} data
        * @param {File} svgFile
        * @param {File} svgFileAlt
        * @param {File} banner
        * @returns {ContentPostContentLocationDownloadDto[]}
    ******************************************************************************************************/
    ContentController.PostLocation = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.media)
            fd.append("media", data.media);
        fd.append("data", JSON.stringify(data.data));
        if (data.svgFile)
            fd.append("svgFile", data.svgFile);
        if (data.svgFileAlt)
            fd.append("svgFileAlt", data.svgFileAlt);
        if (data.banner)
            fd.append("banner", data.banner);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/ContentPostContentLocation", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/content/Category/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {File} media
        * @param {CategoryUploadDto} data
        * @param {File} svgFile
        * @param {File} svgFileAlt
        * @param {File} banner
        * @returns {CategoryDownloadDto}
    ******************************************************************************************************/
    ContentController.PatchCategory = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.media)
            fd.append("media", data.media);
        fd.append("data", JSON.stringify(data.data));
        if (data.svgFile)
            fd.append("svgFile", data.svgFile);
        if (data.svgFileAlt)
            fd.append("svgFileAlt", data.svgFileAlt);
        if (data.banner)
            fd.append("banner", data.banner);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/Category/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/content/ContentPostMediaType/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {File} media
        * @param {ContentPostMediaTypeUploadDto} data
        * @param {File} svgFile
        * @param {File} svgFileAlt
        * @param {File} banner
        * @returns {ContentPostMediaTypeDownloadDto[]}
    ******************************************************************************************************/
    ContentController.PatchMediaType = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.media)
            fd.append("media", data.media);
        fd.append("data", JSON.stringify(data.data));
        if (data.svgFile)
            fd.append("svgFile", data.svgFile);
        if (data.svgFileAlt)
            fd.append("svgFileAlt", data.svgFileAlt);
        if (data.banner)
            fd.append("banner", data.banner);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/ContentPostMediaType/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/content/ContentPostContentType/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {File} media
        * @param {ContentPostContentTypeUploadDto} data
        * @param {File} svgFile
        * @param {File} svgFileAlt
        * @param {File} banner
        * @returns {ContentPostContentTypeDownloadDto[]}
    ******************************************************************************************************/
    ContentController.PatchContentType = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.media)
            fd.append("media", data.media);
        fd.append("data", JSON.stringify(data.data));
        if (data.svgFile)
            fd.append("svgFile", data.svgFile);
        if (data.svgFileAlt)
            fd.append("svgFileAlt", data.svgFileAlt);
        if (data.banner)
            fd.append("banner", data.banner);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/ContentPostContentType/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/content/ContentPostContentLocation/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {File} media
        * @param {ContentPostContentLocationUploadDto} data
        * @param {File} svgFile
        * @param {File} svgFileAlt
        * @param {File} banner
        * @returns {ContentPostContentLocationDownloadDto[]}
    ******************************************************************************************************/
    ContentController.PatchLocation = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.media)
            fd.append("media", data.media);
        fd.append("data", JSON.stringify(data.data));
        if (data.svgFile)
            fd.append("svgFile", data.svgFile);
        if (data.svgFileAlt)
            fd.append("svgFileAlt", data.svgFileAlt);
        if (data.banner)
            fd.append("banner", data.banner);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/ContentPostContentLocation/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/content/{id}" and http method "DELETE" to call the back-end.
    
        * @param {string} id
        * @returns {void}
    ******************************************************************************************************/
    ContentController.DeleteContent = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/{id}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/content/Category/{id}/{groupid}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {string} groupid
        * @returns {CategoryDownloadDto[]}
    ******************************************************************************************************/
    ContentController.CopyCategory = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/Category/{id}/{groupid}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/content/ContentPostMediaType/{id}/{groupid}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {string} groupid
        * @returns {ContentPostMediaTypeDownloadDto[]}
    ******************************************************************************************************/
    ContentController.CopyMediaType = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/ContentPostMediaType/{id}/{groupid}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/content/ContentPostContentType/{id}/{groupid}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {string} groupid
        * @returns {ContentPostContentTypeDownloadDto[]}
    ******************************************************************************************************/
    ContentController.CopyContentType = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/ContentPostContentType/{id}/{groupid}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/content/ContentPostContentLocation/{id}/{groupid}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {string} groupid
        * @returns {ContentPostContentLocationDownloadDto[]}
    ******************************************************************************************************/
    ContentController.CopyContentLocation = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/ContentPostContentLocation/{id}/{groupid}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    return ContentController;
}());
export { ContentController };
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=ContentController.js.map